import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"
import { Button } from "reactstrap"

const recentExperiencesListColumns = history => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, exp) => <>{exp?.id}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, exp) => <>{exp.name}</>,
    },
    {
      text: "# of Users",
      dataField: "guests_nr",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, exp) => (
        <>{exp.guests_nr ? exp.guests_nr : "-"}</>
      ),
    },
    {
      text: "Created On",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, exp) => <>{getFormattedTime(exp?.created_at)}</>,
    },
    {
      text: "# of Clicks",
      dataField: "event_app_open_nr",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, exp) => (
        <>{exp?.event_app_open_nr ? exp?.event_app_open_nr : "-"}</>
      ),
    },
    {
      text: "Reports",
      dataField: "reports",
      isDummyField: true,
      formatter: (cellContent, exp) => (
        <Button
          type="button"
          color="primary"
          className="btn-sm btn-rounded"
          onClick={() => history.push(`/event-reports/${exp?.id}`)}
        >
          View Reports
        </Button>
      ),
    },
  ]
}

export default recentExperiencesListColumns
